var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1639_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.456 28.2712C11.5049 26.7037 10.959 24.8745 10.959 22.9208C10.959 17.1127 15.7839 12.4043 21.7358 12.4043C25.6749 12.4043 29.1203 14.4666 31.0002 17.5452C32.8801 14.4667 36.3255 12.4044 40.2646 12.4044C46.2164 12.4044 51.0414 17.1128 51.0414 22.9209C51.0414 24.8745 50.4955 26.7037 49.5444 28.2712H49.7187L32.7027 50.5957L14.5911 30.794C13.9587 30.2472 13.3927 29.6289 12.9063 28.9521L12.2836 28.2712H12.456Z",
    fill: "url(#paint0_radial_1639_2458)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6762 44.3567C24.6344 39.1258 16.0856 27.5016 14.5509 25.0719C12.2819 21.4796 14.929 13.917 22.1135 15.6186C18.0802 17.1941 13.9461 25.1475 29.6762 44.3567Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6762 44.3567C24.6344 39.1258 16.0856 27.5016 14.5509 25.0719C12.2819 21.4796 14.929 13.917 22.1135 15.6186C18.0802 17.1941 13.9461 25.1475 29.6762 44.3567Z",
    stroke: "white",
    strokeWidth: 0.378133
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1639_2458",
    x: 4.90886,
    y: 6.35416,
    width: 55.2073,
    height: 53.3167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.51253,
    dy: 1.51253
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78133
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1639_2458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1639_2458",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.51253,
    dy: -1.89066
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89066
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1639_2458"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1639_2458",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5788 21.9521) rotate(54.0191) scale(34.4529 35.0089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E81092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/HeartFilled.001898bef232ce28790e3c1b40b99603.svg";
export { ForwardRef as ReactComponent };